/* eslint-disable max-len */
import { MetaTag } from '@thd-nucleus/thd-helmet';
import { formatDescription } from '../../helpers/product-helpers';

export const getRobotsTag = (availabilityType) => {
  if (availabilityType?.discontinued) {
    return new MetaTag({ name: 'robots', content: 'noindex', id: 'robots' });
  }
  return new MetaTag({ name: 'robots', content: 'max-image-preview:large', id: 'robots' });
};

export const getAggregateReviews = (data) => {
  const aggregateReviews = {};
  if (data?.reviews?.Includes?.Products?.store?.FilteredReviewStatistics?.AverageOverallRating
    && data?.reviews?.TotalResults) {
    aggregateReviews.averageRating = data.reviews.Includes.Products.store.FilteredReviewStatistics.AverageOverallRating;
    aggregateReviews.totalReviews = data.reviews.TotalResults;
  }
  return aggregateReviews;
};

export const getBrandName = (identifiers) => {
  return (!identifiers?.brandName || identifiers?.brandName?.toLowerCase() === 'unbranded') ? '' : identifiers?.brandName;
};

export const getTitle = (brandName, identifiers, props) => {
  const defaultTitle = `${brandName} ${identifiers?.productLabel || ''} ${identifiers?.modelNumber || ''} ${props?.pageNumber ? '| Pg' + props.pageNumber : ''}`.trim();

  return props?.pageTitle?.trim() || `${defaultTitle} - The Home Depot`;
};

export const getDescription = (seo, details, props) => {
  const { seoDescription } = seo || {};
  const defaultDescription = formatDescription(seoDescription || details?.description);
  const description = props?.pageDescription || defaultDescription;

  return description;
};
